export default __webpack_public_path__ + "static/media/E2BAuto-160x600-px.5a44bdaa.jpg";